import { render, staticRenderFns } from "./OrganisationQuota.vue?vue&type=template&id=54dd63ca&scoped=true"
import script from "./OrganisationQuota.vue?vue&type=script&lang=js"
export * from "./OrganisationQuota.vue?vue&type=script&lang=js"
import style0 from "./OrganisationQuota.vue?vue&type=style&index=0&id=54dd63ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd63ca",
  null
  
)

export default component.exports